/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import ShowTable from "./tablelist";
import Skeleton from "react-loading-skeleton";
import { CSVLink } from "react-csv";
import moment from "moment";
import { Button, Modal, Table, Pagination } from "antd";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import { async } from "q";
import ServiceApi from "../../../../services/ServiceApi";
function setCookies(item) {
  setTimeout(function () {
    window.location.assign(
      "/MaxiOperation/full_detail_job/" +
        item.company_id +
        "/" +
        item.operator_id +
        "/" +
        item.project_id +
        "/" +
        item.job_id
    );
  }, 100);
}
export default function DataTable({
  MasterListData,
  selectJobcategory,
  dataS = [],
  refresh,
  refreshApi,
  isLoading,
  setisLoading,
  actionBtn,
  setactionBtn,
  SelectJobstatus,
  setSelectJobstatus,
  setTabStatusIndex,
  factUpdate,
  LangTranslate,
  dataSCount,
  PageIndex,
  PageSize,
  currentPageS,
}) {
  const columns1 = [
    {
      title: "S/O ID",
      dataIndex: "",
      key: "",

      render: (item) => (
        <Link
          onClick={() => setCookies(item)}
          to="#"
          className="c-blue text-underline"
        >
          {item.so_id}
        </Link>
      ),
    },
    {
      title: "Job",
      dataIndex: "job",
      key: "job",
      render: (item) => (
        <>
          {item !== undefined
            ? item.map((list, index) => (
                <>
                  <span>{list}</span>
                  <br />
                </>
              ))
            : "-"}
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (item) => (
        <>
          {item !== undefined
            ? item.map((list, index) => (
                <>
                  <span>{list}</span>
                  <br />
                </>
              ))
            : "-"}
        </>
      ),
    },
    {
      title: "Sub AckJob",
      dataIndex: "emp_name",
      key: "emp_name",
    },
  ];
  const [Menu, setMenu] = useState([
    { text: "All Job", step: 6, job_status: 1000 },
    // { text: "No Assign M&M", step: 1, job_status: 33 },
    { text: "Assign to M&M", step: 2, job_status: 34 },
    { text: "No Assign Sub", step: 3, job_status: 1 },
    { text: "Assign Sub", step: 4, job_status: 2 },
    { text: "On Process", step: 5, job_status: 3 },
    // { text: "Complete", step: 7, job_status: 999 },
    { text: "No Progress", step: 8, job_status: 99999 },
    // { text: "Request Close", step: 9, job_status: 36 },
    // { text: "Reopen", step: 10, job_status: 66666 },
    { text: "Wait Event end time", step: 11, job_status: 55555 },
  ]);
  const [PageSizeS, setPageSizeS] = useState(40);
  const [pageIndexS, setPageIndexS] = useState(1);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  useEffect(() => {
    PageIndex(pageIndexS);
    PageSize(PageSizeS);
  }, [pageIndexS]);

  const [count, setcount] = useState({
    66666: 0,
    88888: 0,
    77777: 0,
    1000: 0,
    99999: 0,
    33: 0,
    34: 0,
    35: 0,
    1: 0,
    18: 0,
    2: 0,
    3: 0,
    36: 0,
    0: 0,
  });
  const [isActive, setisActive] = useState(0);
  const [isModal, setisModal] = useState(false);

  const [dataModal, setDataModal] = useState([]);
  const [titleModal, setTitleModal] = useState("");

  const [checkAckJob, setcheckAckJob] = useState(false);
  const [reqCloseData, setReqCloseData] = useState([]);
  const unmounted = useRef(false);
  // const Showdatata = dataS;
  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    window.addEventListener("resize", handleResize);

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });
  const Showdatata = dataS?.filter((data) => {
    // if (SelectJobstatus !== 1000) {
    //   if (SelectJobstatus === 33) {
    //     return (
    //       data.main_process_id === SelectJobstatus ||
    //       data.main_process_id === 35
    //     );
    //   } else if (SelectJobstatus === 1) {
    //     return (
    //       data.main_process_id === SelectJobstatus ||
    //       data.main_process_id === 18
    //     );
    //   } else if (SelectJobstatus === 66666 || SelectJobstatus === 55555) {
    //     return true;
    //   } else {
    //     return data.main_process_id === SelectJobstatus;
    //   }
    // } else {
      return dataS;
    // }
  });

  useEffect(() => {
    if (dataSCount.length > 0) {
      let all_data = 0;
      for (var i in dataSCount) {
        if (
          dataSCount[i]["job_status"] !== 99999 &&
          dataSCount[i]["job_status"] !== 88888 &&
          dataSCount[i]["job_status"] !== 77777 &&
          dataSCount[i]["job_status"] !== 66666 &&
          dataSCount[i]["job_status"] !== 55555
        ) {
          all_data = all_data + dataSCount[i].count;
        }
      }
      setcount((data) => ({ ...data, 1000: all_data }));
      if (isActive === 2) {
        checkDateOverSLA();
      }
    } else setcount((data) => ({ ...data, 1000: 0 }));
    // filter
    function filterCount(jobStatus) {
      let count = 0;

      dataSCount.map((dataCount) => {
        if (dataCount.job_status === jobStatus) {
          if (jobStatus === 34 || jobStatus === 36) {
            const result = dataSCount.filter(
              (word) => word.job_status === (jobStatus === 34 ? 77777 : 88888)
            );
            count = result[0].count;
          } else {
            count = dataCount.count;
          }
        }
      });
      return count;
    }
    // Menu.map((menus) => {
    //   if (menus.job_status !== 1000) {
    //     setcount((count) => ({
    //       ...count,
    //       [menus.job_status]: filterCount(menus.job_status),
    //       35: filterCount(35),
    //       18: filterCount(18),
    //       88888: filterCount(88888),
    //       77777: filterCount(77777),
    //       66666: filterCount(66666),
    //       55555: filterCount(55555),
    //       999: "<=3000",
    //     }));
    //   }
    // });

    return () => {
      unmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataS, refreshApi, dataSCount]);
  useEffect(() => {
    const interval = setInterval(() => {
      checkDateOverSLA();
    }, 60000 * 15);
  }, [dataS]);

  useEffect(() => {
    LoadDataReqClose();
  }, [count["88888"] === MasterListData.length]);

  const checkDateOver = (item) => {
    var checkDate = [];
    if (item !== undefined) {
      var setDate = item.replace(/[dhm]/g, "");
      var setDateSplit = setDate.split(":");
      if (setDateSplit.length > 2) {
        checkDate[0] =
          parseInt(setDateSplit[0]) > 0 && parseInt(setDateSplit[0]) > 15
            ? true
            : false;
        checkDate[1] =
          parseInt(setDateSplit[1]) > 0 && parseInt(setDateSplit[1]) > 15
            ? true
            : false;
        checkDate[2] =
          parseInt(setDateSplit[2]) > 0 &&
          parseInt(setDateSplit[2].replace(" ", "")) > 15
            ? true
            : false;
      } else {
        checkDate[0] =
          parseInt(setDateSplit[0]) > 0 && parseInt(setDateSplit[0]) > 15
            ? true
            : false;
        checkDate[1] =
          parseInt(setDateSplit[1]) > 0 && parseInt(setDateSplit[1]) > 15
            ? true
            : false;
      }

      const found = checkDate.find((element) => element === true);
      return found !== undefined ? found : false;
    } else {
      return false;
    }
  };
  const LoadDataReqClose = async () => {
    var setValueso_id = "";
    const result = MasterListData.filter((data) => data.so_id !== "");
    const checkResult = MasterListData.filter((data) => data.so_id === "");
    result.forEach((element) => (setValueso_id += element.so_id + ","));

    const getJob = await ServiceApi.post("JobMaxi/GetRequestCloseDetail", {
      so_id: setValueso_id.substring(0, setValueso_id.length - 1),
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
    });

    if (getJob.data.result.code.toLowerCase() === "p") {
      var setJob = [];
      var setStatus = [];
      for (let i = 0; i < getJob.data.data.length; i++) {
        const result2 = MasterListData.filter(
          (data) => data.so_id === getJob.data.data[i]["so_id"]
        );
        for (let r = 0; r < getJob.data.data[i]["data"].length; r++) {
          setJob.push(getJob.data.data[i]["data"][r]["job_no"]);
          setStatus.push(getJob.data.data[i]["data"][r]["job_status_name"]);
        }
        result2[0]["job"] = setJob;
        result2[0]["status"] = setStatus;
        setJob = [];
        setStatus = [];
      }
    }
  };
  const changeMenu = async (indexPage, jobStatusId) => {
    PageIndex(1);
    PageSize(40);
    if (indexPage !== null) {
      if (jobStatusId === 99999 || jobStatusId === 36) {
        setTitleModal(jobStatusId === 99999 ? "No Progress" : "Request Close");
        if (isActive !== indexPage) {
          setisLoading(true);
        }
        setTabStatusIndex(indexPage);
        setisActive(indexPage);
        setactionBtn([]);
        setSelectJobstatus(jobStatusId);
        refresh(indexPage);
        setisModal(true);
      } else {
        if (isActive !== indexPage) {
          setisLoading(true);
        }
        setTabStatusIndex(indexPage);
        setisActive(indexPage);
        setactionBtn([]);
        setSelectJobstatus(jobStatusId);
        refresh(indexPage);
      }
    }
  };
  const checkDateOverSLA = () => {
    const result = dataS.filter(
      (word) => word.job_status === 34 && checkDateOver(word.opened)
    );
    if (isActive === 2) {
      result.forEach((element) => (element["OverSLA"] = true));
      setcheckAckJob(result.length > 0 ? true : false);
    }
  };
  // function onShowSizeChange(current, pageSize) {
  //   PageIndex(pageIcurrentndexS);
  //   PageSize(PageSizeS);
  // };
 
  return (
    <>
      <div className="mt-0">
        <div className="row">
          <div
            className="col-lg-10 col-sm-auto mr-auto"
            style={{ paddingLeft: 10 }}
          >
            <ul className="nav row">
              {(parseInt(Cookies.get("companyid")) === 3 &&
              parseInt(Cookies.get("operator_id")) === 4 &&
              parseInt(Cookies.get("project_id")) === 6
                ? Menu
                : Menu.filter((word) => word.step !== 8)
              ).map((data, index) => {
                return (
                  <li
                    key={`menu_detail_${index}`}
                    className="nav-item m-1 col-sm-auto"
                    style={
                      isActive === index
                        ? {
                            backgroundColor: "#0500A3",
                            color: "#ffff",
                            textAlign: "center",
                            height: 25,
                            // minWidth: "25px",
                          }
                        : {
                            height: 25,
                            backgroundColor:
                              checkAckJob && index === 2
                                ? "red"
                                : index === 8 || index === 7
                                ? count[data.job_status] > 0
                                  ? "red"
                                  : "rgb(255 243 128 / 60%)"
                                : "#DEDEDE",
                            color:
                              checkAckJob && index === 2
                                ? "#fff"
                                : index === 8 || index === 7
                                ? count[data.job_status] > 0
                                  ? "#fff"
                                  : "rgb(135 75 0)"
                                : "#0500A3",
                            textAlign: "center",
                            // minWidth: "25px",
                          }
                    }
                  >
                    <button
                      href={null}
                      className="nav-link font-thai-b fs-18"
                      style={{ lineHeight: "8px", width: "100%" }}
                      onClick={() => changeMenu(index, data.job_status)}
                      disabled={isLoading}
                    >
                      {/* {data.job_status === 33 ?
                            `${data.text} (${count[data.job_status] + count[35]})`
                            : data.job_status === 1
                              ? `${data.text} (${count[data.job_status] + count[18]})`
                              : `${data.text} (${count[data.job_status === 34 ? 77777 : data.job_status === 36 ? 88888 : data.job_status]})`} */}
                      {data.job_status === 33
                        ? `${data.text}`
                        : data.job_status === 1
                        ? `${data.text}`
                        : `${data.text}`}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
          <div
            className="col-lg-2 col-sm-auto"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingRight: 10,
              marginTop: 3,
            }}
          >
            {dataS && (
              <CSVLink
                data={dataS.map((s) => {
                  return {
                    job_no: s.job_no,
                    so_id: s.so_id,
                    sap_id: s.sap_id,
                    site_code: s.asset_code,
                    site_name: s.asset_name,
                    center: s.area_code,
                    open_time: moment(s.first_Start_date).format(
                      "DD/MM/YYYY HH:mm:ss"
                    ),
                    job_status_name: s.job_status_name,
                    restored_time: s.restoredTime,
                    job_detail: s.problem_detail,
                  };
                })}
                filename={`maxi_job_list_${moment().format("DD_MM_YYYY")}.csv`}
              >
                <Button
                  icon={<DownloadOutlined />}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "auto",
                  }}
                >
                  Export
                </Button>
              </CSVLink>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {isLoading ? (
              <Skeleton height={dimensions.height - 160}></Skeleton>
            ) : (
              <>
                <ShowTable
                  dataSource={Showdatata ? Showdatata : null}
                  actionBtn={actionBtn ? actionBtn : null}
                  currentPage={isActive}
                  SelectJobstatus={SelectJobstatus}
                  setisLoading={setisLoading}
                  factUpdate={factUpdate}
                  LangTranslate={LangTranslate}
                  // CountData={count[SelectJobstatus]}
                  CountData={dataSCount[0].count}
                  PageIndex={setPageIndexS}
                  PageSize={setPageSizeS}
                  currentPageS={currentPageS}
                ></ShowTable>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal
        title={titleModal}
        width={800}
        visible={isModal}
        onCancel={() => setisModal(false)}
        style={{ top: "5px" }}
      >
        <Table
          dataSource={MasterListData}
          columns={columns1}
          scroll={{ y: 450 }}
          pagination={true}
        />
        {/* <Pagination defaultCurrent={currentPageS} total={CountData}  className="m-2" style={{float: "right"}} onChange={onShowSizeChange}/> */}
      </Modal>
    </>
  );
}
